import React, { MouseEvent } from 'react';
import { RouterStore } from 'mobx-state-router';
import { MenuProps } from 'antd';
import { LogoutOutlined, MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons';
import { MenuIcons } from '../IconComponents';
import { MenuMode } from 'rc-menu/lib/interface';
import { IPage } from '../../interfaces';
import { setRouterStoreCurrentComponent } from '../../middleware';
import { tP } from '../../translate';

export enum MenuType {
    // VERTICAL = 'vertical',
    HORIZONTAL = 'horizontal',
    INLINE = 'inline',
    MOBILE = 'mobile',
}

export const getMenuMode = (menuType: MenuType): MenuMode => {
    return menuType === MenuType.MOBILE ? MenuType.INLINE : menuType;
};

export interface IMainMenuProps {
    onChangeCollapse?(): void;
    menuType: MenuType;
    collapsed?: boolean;
}

export type IMenuItem = Required<MenuProps>['items'][number];

export type IMakeMenuItems = {
    menu: IPage[];
    collapsed?: boolean;
    onChangeCollapse?(): void;
    profileLabel: string;
    routerStore: RouterStore;
    selectKeys?: string[];
    type?: MenuType;
};

export const makeMenuItems = ({
    menu,
    collapsed,
    onChangeCollapse,
    profileLabel,
    routerStore,
    selectKeys,
    type,
}: IMakeMenuItems): MenuProps['items'] => {
    const menuItems: MenuProps['items'] = [];

    if (type === MenuType.INLINE) {
        menuItems.push({
            key: 'collapse',
            label: !collapsed ? tP('Collapse') : tP('Uncollapse'),
            icon: collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />,
        });
        menuItems.push({ type: 'divider' });
    }

    menu.forEach((item: IPage): void => {
        const goTo = (event: MouseEvent<HTMLButtonElement | HTMLAnchorElement>): void => {
            if (!(event.ctrlKey || event.metaKey || event.altKey || event.shiftKey || item.url === '#')) {
                event.preventDefault();
                routerStore.goTo(item.componentName);
                setRouterStoreCurrentComponent({ routeName: item.componentName });
            }
        };

        if (item.isMenuSeparator) {
            menuItems.push({ type: 'divider' });
        } else {
            const title = item.title === 'MY_PROFILE_NAME' ? profileLabel : item.title ? tP(item.title) : '';
            const url = item.url || '#';
            let menuItem: IMenuItem = {
                key: item.id,
                label: (
                    <a href={url} onClick={goTo}>
                        {title}
                    </a>
                ),
                icon: item.menuIcon ? <MenuIcons iconName={item.menuIcon} /> : null,
            };

            if (item.subMenu && Array.isArray(item.subMenu) && item.subMenu.length) {
                menuItem = {
                    ...menuItem,
                    children: makeMenuItems({
                        menu: item.subMenu,
                        collapsed,
                        onChangeCollapse,
                        profileLabel,
                        routerStore,
                        selectKeys,
                    }),
                };
            }
            menuItems.push(menuItem);
        }
    });

    if (type === MenuType.MOBILE) {
        menuItems.push({ type: 'divider' });
        menuItems.push({
            key: 'logOut',
            label: <a href={'#'}>{tP('Log out')}</a>,
            icon: <LogoutOutlined />,
        });
    }

    return menuItems;
};
